export default "__VITE_ASSET__DXhaeUqs__"